/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
import { supabase } from './supabaseClient';

const adminBearer = import.meta.env.VITE_SHANEWORK_PLATFORM_KEY as string | undefined;

type InvokeOptions = {
  body?: Record<string, unknown>;
  bearer?: string;
};

type FunctionEnvelope = {
  success?: boolean;
  message?: string;
};

export type FunctionResult<T> = {
  data: T | null;
  error: string | null;
};

const isEnvelope = (value: unknown): value is FunctionEnvelope =>
  typeof value === 'object' && value !== null && ('success' in value || 'message' in value);

export const invokeFunction = async <T>(name: string, { body, bearer }: InvokeOptions = {}): Promise<FunctionResult<T>> => {
  const headers: Record<string, string> = {};
  const token = bearer ?? adminBearer;

  if (!token) {
    return { data: null, error: 'Missing Shanework platform key. Set VITE_SHANEWORK_PLATFORM_KEY in your env.' };
  }

  headers['x-shanework-key'] = token;

  const response = await supabase.functions.invoke<unknown>(name, {
    body,
    headers,
  });

  if (response.error) {
    return { data: null, error: response.error.message };
  }

  const payload = response.data;

  if (isEnvelope(payload)) {
    const envelope = payload;
    if (envelope.success === false && envelope.message) {
      return { data: null, error: envelope.message };
    }
  }

  return { data: (payload ?? null) as T | null, error: null };
};

